module.exports = __webpack_public_path__ + "img/mobile_map_calderaradireno.58319163.svg";